exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record-container[data-v-546a7152]{display:flex;flex-direction:column;margin-bottom:10px}.record[data-v-546a7152]{display:flex;justify-content:space-between;padding:10px}.tw-link[data-v-546a7152]{text-decoration:underline;cursor:pointer}", ""]);

// exports
